// 报表接口 (监控大盘)
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';
import { getAMergeDeductFilterOptions as _getAMergeDeductFilterOptions } from '@/views/jkdp/models/data';

const {baseApi} = apiPrefix;

// 短险监控所属期 - 列表
export function getShortInsureTermList(params){
  return post(baseApi + '/policyMonitor/queryReport', params);
}
// 短险监控所属期 - 链路选项列表
export function getLinkOptions(params){
  return get(baseApi + '/policyMonitor/getLinkList', params);
}


// 短险监控当日 - 保司选项列表
export function getCompanyOptions(params){
  return get(baseApi + '/common/company', params);
}
// 短险监控当日 - 产品选项列表
export function getProductCodeOptions(params){
  return get(baseApi + '/common/insuranceProduct', params);
}
// 短险监控当日 - 经纪公司选项列表
export function getBrokerCompanyOptions(params){
  return get(baseApi + '/common/brokerCompany', params);
}
// 短险监控当日 - 收银台选项列表
export function getPayWayOptions(params){
  return get(baseApi + '/common/payWay', params);
}
// 短险监控当日 - 列表
export function getShortInsureTodayList(params){
  return post(baseApi + '/monitorReport/policyIncome', params);
}



// 坐席姓名 - 选项
export function getAgentIdOptions(params){
  return get(baseApi + '/jobOrder/getAgentByOrgId', params);
}
// 客服评价报表 - 列表
export function getSeatEvaluateList(params){
  return post(baseApi + '/jobOrder/seatEvaluateReport', params);
}



// 获取挽单坐席选项列表
export function getJobOrderRetentionAgentOptions(params={}){
  return post(baseApi + '/jobOrder/retentionAgent', params);
}
// 脱退报表 - 列表
export function getDetainmentTtList(params={}){
  const payload = {dataType: 1, ...params};
  return post(baseApi + '/jobOrder/retentionExport', payload);
}
// 脱退报表 - 下载
export function detainmentTtExport(params={}){
  const payload = {dataType: 1, downLoad: true, ...params};
  return post(baseApi + '/jobOrder/retentionExport', payload, {responseType: "blob"});
}
// 回拨挽单报表 - 列表
export const getDetainmentCallbackList = (params={}) => getDetainmentTtList({dataType: 2, ...params});
// 回拨挽单报表 - 下载
export const detainmentCallbackExport = (params={}) => detainmentTtExport({dataType: 2, ...params});
// 进线挽单报表 - 列表
export const getDetainmentIncomeList = (params={}) => getDetainmentTtList({dataType: 3, ...params});
// 进线挽单报表 - 下载
export const detainmentIncomeExport = (params={}) => detainmentTtExport({dataType: 3, ...params});
// 重疾均分挽单报表 - 列表
export const getDetainmentZjJfList = (params={}) => getDetainmentTtList({dataType: 4, ...params});
// 重疾均分挽单报表 - 下载
export const detainmentZjJfExport = (params={}) => detainmentTtExport({dataType: 4, ...params});



// 零犀投诉报表 - 列表
export function getLxComplaintReportList(params){
  return post(baseApi + '/jobOrder/lxComplaintReport', params);
  // return post(baseApi + '/jobOrder/flushLxComplaintReport', params);
}
// 客服通话汇总表 - 列表
export function getCallRecordReportList(params){
  return post(baseApi + '/jobOrder/callRecordReport', params);
}
// 当日口径结案报表 - 列表
export function getSettleReportList(params){
  return post(baseApi + '/jobOrder/closeReport', params);
}
// 统计报表 - 列表
export function getComplaintStatisticsJobAll(params){
  return post(baseApi + '/jobOrder/complaintStatisticsJobAll', params);
}
// 投诉来源 - 列表
export function getComplaintSourceList(params){
  return post(baseApi + '/jobOrder/queryComplainReport', params);
}
// 超时自动处理监控 - 列表
export function getOvertimeAutoHandleList(params){
    return post(baseApi + '/jobOrder/timeoutExport', params);
}
// 400进线报表 - 列表
export function getLineInList(params){
  return post(baseApi + '/jobOrder/timeoutExport', params);
}
// 每日工作人数 - 列表
export function getDailyWorkPeopleList(params){
  return post(`${baseApi}/jobOrder/queryComplainReport`, params);
}
// 来电统计 - 列表
export function getCallInList(params){
  return post(`${baseApi}/jobOrder/queryCallInReport`, params);
}
// 工单人群 - 列表
export function getComplaintPeopleList(params){
  return post(baseApi + '/jobOrder/queryComplainReport', params);
}
// 工单处理结果 - 列表
export function getComplaintResultList(params){
  return post(baseApi + '/jobOrder/queryResult', params);
}
// 投诉指标报表 - 列表
export const getComplaintTargetList = (params) => post(`${baseApi}/jobOrder/complaintIndex`, params);
// 来源分布报表 - 列表
export const getComplaintOriginList = (params) => post(`${baseApi}/jobOrder/sourceDistribution`, params);
// 投诉报表 - 二次监管工单 - 列表
export const getSecondJggdList = (params) => post(`${baseApi}/jobOrder/regulatoryReport`, params);
// 投诉报表 - 客服通话数据表 - 列表
export const getKfCallList = (params) => post(`${baseApi}/jobOrder/seatCallReport`, params);
// 投诉报表 - 企微消息数据监控 - 列表
export const getQwReplayList = (params) => post(`${baseApi}/jobOrder/getQwMessageMonitor`, params);


// 投诉处理能力 - 列表
export function getComplaintDisposeStatsList(params){
  return post(baseApi + '/jobOrder/queryComplaintProcess', params);
}

// 下载零犀客诉模版
export const getLxExcelDownTemplate = (params) => {
    return get(baseApi + "/jobOrder/getLxExcel", params, {responseType: "blob"});
}
// 上传零犀客诉数据
export const putLxExcelUpload = (params) => {
    const data = new FormData();
    Object.keys(params).forEach((item) => {
        data.append(item, params[item]);
    });

    return post(baseApi + "/jobOrder/putLxExcel", data, {
        headers: {"Contennt-Type": "multipart/form-data",},
        noValid: true,
    });
}


// a段合并扣费 - 筛选选项集合
export function getAMergeDeductFilterOptions(params){
  return _getAMergeDeductFilterOptions(params);
}
// a段合并扣费 - 列表
export function getAMergeDeductList(params){
  return post(baseApi + '/addDeductMonitor/getReport', params);
}
// 降级扣费 - 列表
export function getARelegateDeductList(params){
  return post(baseApi + '/addDeductMonitor/getDownReport', params);
}
